import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
// import counterReducer from '../features/counter/counterSlice';
import formAfterSignUpReducer from '../features/formAfterSignUp/formAfterSignUpSlice';
import authReducer from '../features/authentication/authSlice';
import packageReducer from '../features/packages/packagesSlice';
import { businessRegistration } from '../features/businessRegistration/businessRegistrationSlice';
import { businessInformation } from '../features/businessInformation/businessInformationSlice';
import { twoFAenable } from '../features/2FAenable/2FAenableSlice';
import navbarReducer from '../features/navbarToggler/navbarSlice';
export const store = configureStore({
  reducer: {
    // counter: counterReducer,
    formAfterSignUp: formAfterSignUpReducer,
    auth: authReducer,
    packages: packageReducer,
    [businessRegistration.reducerPath]: businessRegistration.reducer,
    [businessInformation.reducerPath]: businessInformation.reducer,
    [twoFAenable.reducerPath]: twoFAenable.reducer,
    button: navbarReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      businessRegistration.middleware,
      businessInformation.middleware,
      twoFAenable.middleware,
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
